import { Button as ReactAriaButton } from "react-aria-components";

import styles from "./action-chip.module.css";

export type ActionChipProps = {
  /**
   * **Without** the `+`. The affordance belongs to the component, so every
   * call site renders it the same way — the three sites this retires disagreed
   * on whether there was a space after it.
   */
  label: string;
  onPress?: () => void;
  isDisabled?: boolean;
};

/**
 * A chip that adds something.
 *
 * Same pill footprint as `ToggleChip` but a dashed border and a single state:
 * it fires an action rather than holding one. Reach for `ToggleChip` when the
 * chip is a state the user can see, and for this when the chip is an empty
 * slot they can fill.
 */
function ActionChip({ label, onPress, isDisabled }: ActionChipProps) {
  return (
    <ReactAriaButton
      className={styles.chip}
      onPress={onPress}
      isDisabled={isDisabled}
    >
      {`+ ${label}`}
    </ReactAriaButton>
  );
}

export default ActionChip;
